import { render, staticRenderFns } from "./category.vue?vue&type=template&id=34959a96&scoped=true&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"
import style0 from "./category.vue?vue&type=style&index=0&id=34959a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34959a96",
  null
  
)

export default component.exports